import { Box, Container, Stack, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { store } from '../store';
import { updateTokenInStore } from '../utilities/tokenRefresher';

const RedirectRoute = () => {
    const location = useLocation();
    const [isReady, setIsReady] = useState(false);

    const redirectTo = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        const requestedRedirect = searchParams.get('redirectTo');

        if (!requestedRedirect || !requestedRedirect.startsWith('/') || requestedRedirect.startsWith('//')) {
            return '/documents';
        }

        return requestedRedirect;
    }, [location.search]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');

        if (token) {
            updateTokenInStore(store, token);
        }

        setIsReady(true);
    }, [location.search]);

    return (
        <Container component="main" disableGutters>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    minHeight: '100vh',
                }}
            >
                <Stack direction="column" spacing={3} sx={{ textAlign: 'center' }}>
                    <Typography variant="h5">Redirecting...</Typography>
                    {isReady && <Navigate to={redirectTo} replace />}
                </Stack>
            </Box>
        </Container>
    );
};

export default RedirectRoute;
